module.exports = __webpack_public_path__ + "img/logo_geseco.d9f07dee.jpg";